/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { Field } from 'formik'

import { EuiCheckbox } from '@elastic/eui'

import type { FormattedMessage } from '@modules/i18n'

import type { ReactElement, FunctionComponent } from 'react'

interface Props {
  id: string
  label: string | ReactElement<typeof FormattedMessage>
  name: string
}

export const CuiFormCheckbox: FunctionComponent<Props> = ({ id, label, name }) => (
  <Field name={name}>
    {({ field: { onChange, onBlur, value } }) => (
      <EuiCheckbox
        id={id}
        label={label}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        checked={value}
      />
    )}
  </Field>
)
